import { ChangeBusinessDetails } from './ChangeBusinessDetails';

export class ChangeBodyScripts extends ChangeBusinessDetails {
  type: string = 'ChangeBodyScripts';
}
